
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hOsWM", function(module, exports) {

$parcel$export(module.exports, "LabelsMovedChangeboarding", () => $c7565fc42111d82b$export$83a880bf3267a226);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $2W0qg = parcelRequire("2W0qg");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $ci7Ox = parcelRequire("ci7Ox");

var $lnqHu = parcelRequire("lnqHu");

var $1qfLF = parcelRequire("1qfLF");

var $ivb8S = parcelRequire("ivb8S");

var $dBcar = parcelRequire("dBcar");

var $aWwYt = parcelRequire("aWwYt");

var $dIouf = parcelRequire("dIouf");

var $4TcLf = parcelRequire("4TcLf");

var $bzwhi = parcelRequire("bzwhi");
const { IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED: $c7565fc42111d82b$var$IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED } = (0, $dBcar.ONBOARDING_EXPERIENCES);
const $c7565fc42111d82b$var$boxStyle = (0, $ecnYn.xcss)({
    width: '100%',
    maxWidth: '760px',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderWidth: 'border.width',
    padding: 'space.200',
    marginTop: 'space.1000',
    marginBottom: 'space.500',
    marginInline: 'auto'
});
const $c7565fc42111d82b$var$spacerStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.1000',
    marginBottom: 'space.500',
    padding: 'space.200'
});
const $c7565fc42111d82b$var$linkButtonStyle = (0, $ecnYn.xcss)({
    color: 'color.link',
    marginLeft: 'space.050'
});
const $c7565fc42111d82b$export$83a880bf3267a226 = ()=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { goToStep: goToStep } = (0, $4TcLf.useMoreActionsObjectSidebarTourActions)();
    const { setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const { data: data, error: error, loading: loading } = (0, $ivb8S.useGetOnboardingState)([
        $c7565fc42111d82b$var$IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED
    ]);
    const isDismissed = data?.onboardingState[0].value === 'true';
    if (isDismissed || loading) // This is just a spacer to keep some distance between the content and footer.
    // When this changeboarding is eventually removed, we should probably just make this be a bottom margin on content or a top margin on the footer.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $c7565fc42111d82b$var$spacerStyle
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $c7565fc42111d82b$var$boxStyle,
        justifyContent: "space-between",
        alignItems: "center",
        "data-vc": "labels-moved-changeboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        gap: "space.100",
        alignItems: "center",
        justifyContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$c7565fc42111d82b$var$i18n.labelsMoved,
        values: {
            bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
                    color: "color.text",
                    weight: "medium"
                }, chunks),
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
                    onClick: ()=>{
                        setSidebarControlExpandCollapsedState('expanded');
                        goToStep((0, $bzwhi.MoreActionsObjectSidebarTourSteps).SECOND);
                    },
                    padding: "space.0",
                    backgroundColor: "color.background.neutral.subtle",
                    xcss: $c7565fc42111d82b$var$linkButtonStyle
                }, chunks)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))),
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $c7565fc42111d82b$var$i18n.dismiss),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>{
            setOnboardingState({
                key: $c7565fc42111d82b$var$IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED,
                value: 'true'
            });
        }
    }));
};
const $c7565fc42111d82b$var$i18n = (0, $2nPZH.defineMessages)({
    labelsMoved: {
        id: "object-sidebar-components.labels-changeboarding.message",
        defaultMessage: "<bold>Looking for labels?</bold> They can now be found in the details panel on the floating action bar. <link>Show me</link>"
    },
    dismiss: {
        id: "object-sidebar-components.labels-changeboarding.dismiss",
        defaultMessage: "Dismiss"
    }
});

});


//# sourceMappingURL=LabelsMovedChangeboarding.a2bfbcaa.js.map
